import { render, staticRenderFns } from "./CreditsConfig.vue?vue&type=template&id=193faae2&scoped=true"
import script from "./CreditsConfig.vue?vue&type=script&lang=js"
export * from "./CreditsConfig.vue?vue&type=script&lang=js"
import style0 from "./CreditsConfig.vue?vue&type=style&index=0&id=193faae2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193faae2",
  null
  
)

export default component.exports